module.exports = __webpack_public_path__ + "img/monocycle-enclose.f32fb1b6.jpg";